import PropTypes from 'prop-types';
import styled from '@emotion/styled/macro';
import { css } from '@emotion/react';
import { colors, leading } from '../../styles/theme';
import { H5 } from '../../base';
import { LinkButton } from '../../form';

const DeleteHeader = styled(H5)`
  display: inline;
  color: ${colors.black};
`;

const ConfirmButton = styled(LinkButton)`
  color: ${colors.white};
  border-radius: 20px;
  background: ${colors.red.secondary};
  margin: 0 5px;
  height: 24px;
  line-height: 24px;
  &:hover {
    background: ${colors.red.primary};
    text-decoration: none;
  }
  &:last-child {
    margin-right: 0;
  }
`;

const CancelButton = styled(ConfirmButton)`
  color: ${colors.grey.primary};
  background: none;
  &:hover {
    background: none;
    color: ${colors.black};
  }
`;

const DeleteContent = styled('div')`
  display: flex;
  width: 100%;
  align-items: center;
`;

const DeleteActions = styled('div')``;

const shortOverlay = css`
  align-items: center;
  ${DeleteContent} {
    flex-direction: row;
    justify-content: space-between;
  }
`;

const tallOverlay = css`
  ${DeleteHeader} {
    margin-bottom: ${leading.half};
  }
  ${DeleteContent} {
    flex-direction: column;
    height: 80%;
    position: relative;
    top: 20%;
  }
`;

const Overlay = styled('div')`
  background: ${colors.red.lightest};
  bottom: 0;
  display: flex;
  font-size: 12px;
  height: 100%;
  left: 0;
  line-height: 18px;
  margin: 0 auto;
  position: absolute;
  right: 0;
  text-align: center;
  top: 0;
  z-index: 210;
  padding: 10px 20px;
  border-radius: 3px;
  box-shadow: inset 0 0 1px 1px ${colors.red.secondary};
  box-sizing: border-box;
  ${(props) => (props.size === 'short' ? shortOverlay : tallOverlay)}
`;

const DeleteConfirmation = (props) => {
  const { isOpen, onCancel, onDelete, children, size } = props;

  return (
    <>
      {isOpen && (
        <Overlay size={size}>
          <DeleteContent>
            <DeleteHeader>Are you sure?</DeleteHeader>
            <DeleteActions>
              <CancelButton size="small" onClick={onCancel}>
                Cancel
              </CancelButton>
              <ConfirmButton size="small" onClick={onDelete}>
                Delete
              </ConfirmButton>
            </DeleteActions>
          </DeleteContent>
        </Overlay>
      )}

      {children}
    </>
  );
};

DeleteConfirmation.defaultProps = {
  isOpen: false,
  size: '',
};

DeleteConfirmation.propTypes = {
  isOpen: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  size: PropTypes.string,
};

export { DeleteConfirmation };
